module.exports = __webpack_public_path__ + "img/sv16.acf4ae34.svg";